import { useMutation } from '@tanstack/react-query';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import useRemoveDetailRow from './useRemoveDetailRow';
import messages from '../messages';
const useToggleIntraCompanyBilling = () => {
    const { setShowModalInfo } = useModalContext();
    const { removeDetailRow } = useRemoveDetailRow();
    const intl = useIntl();
    const { mutateAsync } = useMutation(values => api.base.put(`${config.appUrls.api}/api/IntraCompany/NeverIntraCompany/${values.registrationId}`, null, {
        params: { neverInvoice: !values.noIntraCompanyBilling },
    }), {
        onSuccess: (_, x) => {
            removeDetailRow(x);
            ToastrService.success();
        },
        onError: e => {
            HandleHttpError(intl)(e);
        },
    });
    const toggleIntraCompanyBilling = async (reg) => {
        if (reg.noIntraCompanyBilling) {
            // Make active again
            await mutateAsync(reg);
        }
        else {
            return new Promise((resolve, reject) => {
                setShowModalInfo({
                    modalType: ModalType.YesNo,
                    title: intl.formatMessage(messages.NeverInvoiceRegistration),
                    message: intl.formatMessage(messages.DoNotIntraCompanyBillRegistrationConfirm),
                    onSave: async () => {
                        await mutateAsync(reg);
                        resolve();
                    },
                    onClose: async () => {
                        reject();
                    },
                });
            });
        }
    };
    return { toggleIntraCompanyBilling };
};
export default useToggleIntraCompanyBilling;
